import translating from '../translate.json';

const Schedule = () => {
  return (
    <div className="medical-info-snapshot">
      <div className="wrappper-snapshot-header">
        <div className="snapshot-title">{translating.schedule}</div>
      </div>
    </div>
  );
};

export default Schedule;
